import React from 'react';
import { Link } from "@remix-run/react";
import { css, styled } from 'styled-components';
import { Colors } from '../../../../play-core/styles/Colors';
import { Device } from '../../../../play-core/styles/Device';
import { Fonts } from '../../../../play-core/styles/Fonts';
import { jsx as _jsx } from "react/jsx-runtime";
export const horizontalPadding = 14;
export const Layout = styled.li.withConfig({
  displayName: "NavigationTabLinkstyles__Layout",
  componentId: "sc-e4ig3l-0"
})([""]);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const StyledLink = styled(({
  isActive,
  ...props
}) => /*#__PURE__*/_jsx(Link, {
  ...props
})).withConfig({
  shouldForwardProp: () => true
}).withConfig({
  displayName: "NavigationTabLinkstyles__StyledLink",
  componentId: "sc-e4ig3l-1"
})(["padding:16px ", "px;border-radius:2px 2px 0 0;", ";color:", ";white-space:nowrap;line-height:22px;transition:box-shadow 600ms;", "{&:hover{background-color:", ";}}", ""], horizontalPadding, Fonts.regular(16), Colors.GREY_d2d2d2, Device.mouse, Colors.GREY_3a3a3a, props => props.isActive && css`
      box-shadow: 0 -2px 0 #fff inset;
      &:hover {
        background-color: transparent;
      }
    `);